import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { ScoreDisplay } from '../components/ScoreDisplay';
import { students } from '../lib/mockData';
import { Search, Filter, Download, ChevronRight } from 'lucide-react';
interface StudentsProps {
  onNavigate: (page: string, id?: string) => void;
}
export function Students({
  onNavigate
}: StudentsProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredStudents = students.filter(student => student.firstName.toLowerCase().includes(searchTerm.toLowerCase()) || student.lastName.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6" data-id="element-398">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-399">
        <div data-id="element-400">
          <h1 className="text-2xl font-bold text-stone-900" data-id="element-401">Student Roster</h1>
          <p className="text-stone-500 mt-1" data-id="element-402">
            Manage literacy scores and attendance data.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-403">
          <Button variant="outline" icon={<Download size={16} data-id="element-405" />} data-id="element-404">
            Export
          </Button>
          <Button icon={<Filter size={16} data-id="element-407" />} data-id="element-406">Filter</Button>
        </div>
      </div>

      {/* Search Bar */}
      <div className="relative" data-id="element-408">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" size={20} data-id="element-409" />
        <input type="text" placeholder="Search by student name..." className="w-full pl-10 pr-4 py-3 rounded-xl border border-stone-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-shadow" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-410" />
      </div>

      {/* Student List */}
      <Card padding="none" className="overflow-hidden" data-id="element-411">
        <div className="overflow-x-auto" data-id="element-412">
          <table className="w-full text-left text-sm" data-id="element-413">
            <thead className="bg-stone-50 border-b border-stone-200" data-id="element-414">
              <tr data-id="element-415">
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-416">
                  Student
                </th>
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-417">
                  Grade
                </th>
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-418">
                  Reading Level
                </th>
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-419">
                  Attendance
                </th>
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-420">
                  Last Test
                </th>
                <th className="px-6 py-4 font-semibold text-stone-900" data-id="element-421"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100" data-id="element-422">
              {filteredStudents.map(student => <tr key={student.id} className="hover:bg-stone-50 transition-colors cursor-pointer group" onClick={() => onNavigate('student-profile', student.id)} data-id="element-423">
                  <td className="px-6 py-4" data-id="element-424">
                    <div className="font-medium text-stone-900" data-id="element-425">
                      {student.firstName} {student.lastName}
                    </div>
                    <div className="text-xs text-stone-500" data-id="element-426">
                      {student.school}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-stone-600" data-id="element-427">{student.grade}</td>
                  <td className="px-6 py-4" data-id="element-428">
                    <ScoreDisplay score={student.literacyScore} level={student.literacyLevel} isBeginningReader={student.isBeginningReader} compact data-id="element-429" />
                  </td>
                  <td className="px-6 py-4" data-id="element-430">
                    <div className="flex items-center gap-2" data-id="element-431">
                      <div className={`
                        w-1.5 h-1.5 rounded-full
                        ${student.attendanceRate >= 90 ? 'bg-teal-500' : student.attendanceRate >= 80 ? 'bg-amber-500' : 'bg-coral-500'}
                      `} data-id="element-432"></div>
                      <span className="font-medium text-stone-700" data-id="element-433">
                        {student.attendanceRate}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-stone-500" data-id="element-434">
                    {student.lastTestDate}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-435">
                    <ChevronRight className="inline-block text-stone-300 group-hover:text-stone-500 transition-colors" size={20} data-id="element-436" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {filteredStudents.length === 0 && <div className="p-12 text-center text-stone-500" data-id="element-437">
            No students found matching "{searchTerm}"
          </div>}
      </Card>
    </div>;
}